import { render } from "./gsrsu03030401.vue?vue&type=template&id=0fac660a&scoped=true"
import script from "./gsrsu03030401.vue?vue&type=script&lang=js"
export * from "./gsrsu03030401.vue?vue&type=script&lang=js"

import "./gsrsu03030401.vue?vue&type=style&index=0&id=0fac660a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fac660a"]])

export default __exports__